import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide6 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={5}
      total={total}
      label="Integration Gateway"
      kicker={t.kicker}
      onActive={onActive}
      variant="plain"
      bgStyle={{
        "--slide-bg": "linear-gradient(110deg,#020202,#06130f 55%,#030302),radial-gradient(720px 560px at 74% 58%,rgba(216,182,46,.20),transparent 70%)"
      }}
    >

      <div className="split">
        <div>
          
          <h2>{t.title}</h2>
          <p className="lead">{t.body}</p>
          
          <div className="mini-list">
            <div><b>01</b><span>{t.l1}</span></div>
            <div><b>02</b><span>{t.l2}</span></div>
            <div><b>03</b><span>{t.l3}</span></div>
          </div>
        </div>
        
        <div
          className="image-card"
          style={{
            "--image-bg": "repeating-linear-gradient(90deg,rgba(216,182,46,.24) 0 1px,transparent 1px 64px),repeating-linear-gradient(0deg,rgba(255,255,255,.09) 0 1px,transparent 1px 64px),radial-gradient(circle at 48% 42%,rgba(28,190,148,.18),transparent 40%)"
          }}
        >
          <div className="caption">
            <div className="eyebrow">{t.imgEyebrow}</div>
            <h3>{t.imgTitle}</h3>
          </div>
        </div>
      </div>
    </SlideShell>
  );
};


